/*
 * Zugang zu den S400-Teilschemen.
 *
 * Die Metadaten (Familien, Teilschemen, Felder) liegen im Hauptbuendel, weil
 * Palette und Eigenschaftsspalte sie sofort brauchen. Die Zeichnungen sind
 * gut ein Megabyte und kommen erst, wenn ein Teilschema gezeigt wird
 * ({@link loadS400Svgs}).
 */

import { S400_FAMILY_LIST, S400_PART_LIST } from './catalog';
import type { S400Part } from './types';

export type { S400Family, S400Field, S400Part } from './types';

export const S400_FAMILIES = S400_FAMILY_LIST;
export const S400_PARTS = S400_PART_LIST;
export type S400PartMeta = S400Part;

/** Bibliothek im Schluessel `part` des Bausteins. */
export const S400_LIBRARY = 's400';

/** `s400/S3K` aus `S3K`. */
export function s400PartKey(code: string): string {
  return `${S400_LIBRARY}/${code}`;
}

/** Beispielschluessel fuer die Palette; `demo/` loest der Live-Adapter nie auf. */
export function s400DemoKey(fieldId: string): string {
  return `demo/s400/${fieldId}`;
}

const BY_KEY = new Map(S400_PART_LIST.map((p) => [s400PartKey(p.code), p]));

/** Teilschema zu `part` des Bausteins, oder undefined fuer einen unbekannten
 *  Schluessel (andere Bibliothek, umbenanntes Teilschema). */
export function s400Part(key: string | undefined): S400Part | undefined {
  return key ? BY_KEY.get(key) : undefined;
}

let svgs: Promise<Record<string, string>> | null = null;

/** Die Zeichnungen, einmal geladen und dann geteilt. */
export function loadS400Svgs(): Promise<Record<string, string>> {
  svgs ??= import('./svgs.json').then((m) => m.default as Record<string, string>)
    .catch((err: unknown) => { svgs = null; throw err; });
  return svgs;
}
